export const CHANGE_WDID = 'CHANGE_WDID'
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SETSTEP = 'SETSTEP';
export const SETDOCS = 'SETDOCS';
